export default function hamburger() {
	const burger = document.getElementById("hamburger");
	const burgerClose = document.getElementById("hamburgerClose");
	const mainMenu = document.getElementById("menu_offset");
	burger.addEventListener("click", function (e) {
		mainMenu.classList.add("is-active");
	});
	burgerClose.addEventListener("click", function (e) {
		mainMenu.classList.remove("is-active");
	});
}
